import { supabase } from './api'

export async function uploadFile(filename, file) {
    const { data, error } =  await supabase.storage.from('avatars').upload(filename, file, {
        //cacheControl: '3600',
        upsert: true
    })
    console.log("uploadFile", data, error);

}

export async function getFile(filename) {

    const { data, error } = await supabase
        .storage
        .from('avatars')
        .getPublicUrl(filename);

        return data;
}

export async function removeFile(filename) {

    const { data, error } = await supabase
    .storage
    .from('avatars')
    .remove([filename])

    //console.log("removeFile",data,error);
}



